import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const VocabularyCategories = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const selectedAge = searchParams.get('age') || '6-8';
  const language = searchParams.get('language') || 'farsi';

  const categories = [
    'Me / Myself',
    'My Family',
    'My Body',
    'Animals',
    'Colors',
    'Food',
    'Numbers',
    'Shapes',
    'My Classroom',
    'My Clothes',
    'My Routine',
    'Weather',
    'Transportation'
  ];

  const handleCategoryClick = (category) => {
    // Navigate to activities for this category
    // For now, just log - you can add navigation later
    console.log('Selected category:', category);
  };

  const handleBack = () => {
    const hubPath = language === 'english' ? '/dashboard/learning-hub-english' : '/dashboard/learning-hub-farsi';
    navigate(`${hubPath}?age=${selectedAge}`);
  };

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      fontFamily: "'Nunito', sans-serif",
      backgroundColor: '#F4ABBA',
      color: '#333',
      paddingTop: '80px'
    }}>
      {/* Progress Banner */}
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        marginBottom: '30px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '20px'
        }}>
          <div>
            <div style={{ fontSize: '18px', fontWeight: '700', color: '#DD2E44', marginBottom: '5px' }}>
              Vocabulary
            </div>
            <div style={{ fontSize: '14px', color: '#666' }}>
              Choose a category to learn new words
            </div>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
          <h2 style={{
            fontSize: 'clamp(36px, 4vw, 48px)',
            fontWeight: '700',
            fontFamily: "'Fredoka', sans-serif",
            color: '#DD2E44',
            textAlign: 'left',
            margin: 0
          }}>
            Vocabulary Categories
          </h2>
          <button
            onClick={handleBack}
            style={{
              backgroundColor: '#FFF5F7',
              color: '#DD2E44',
              padding: '10px 20px',
              borderRadius: '15px',
              border: '2px solid #DD2E44',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            Back
          </button>
        </div>

        {/* Category Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
          gap: '20px',
          marginBottom: '40px'
        }}>
          {categories.map((category, index) => (
            <div
              key={category}
              onClick={() => handleCategoryClick(category)}
              style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '20px',
                border: '3px solid transparent',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(221, 46, 68, 0.15)',
                textAlign: 'center',
                minHeight: '120px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(221, 46, 68, 0.2)';
                e.currentTarget.style.borderColor = '#9B59B6';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(221, 46, 68, 0.15)';
                e.currentTarget.style.borderColor = 'transparent';
              }}
            >
              <h3 style={{
                fontSize: '24px',
                fontWeight: '700',
                color: '#9B59B6',
                margin: 0,
                fontFamily: "'Nunito', sans-serif"
              }}>
                {category}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VocabularyCategories;
